import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import Providers from '../../hooks/contexts';
import Details from '../EventDetails/details';
import AppBar from '../Header/AppBar';
import FixedBarTheme from '../Header/AppBar/FixedBarTheme';
import * as Style from './layout.styles';

const Layout: FC = () => {

  return (
    <Providers>
      <Style.Layout id="layout-app" data-testid="layout-app">
        <Style.Header id="header-app" data-testid="header-app">
          <FixedBarTheme />
          <Style.Container>
            <AppBar />
            <Details />
          </Style.Container>
        </Style.Header>
        <Style.Container>
          <Style.ContainerChild>
            <Outlet />
          </Style.ContainerChild>
        </Style.Container>
      </Style.Layout>
    </Providers>

  );
};

export default Layout;
